import {createRouter, createWebHistory} from "vue-router";
import TheLayout from "@/src/layouts/TheLayout.vue";
import {onCheckLogin} from "@/src/router/middleware.ts";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/sign-in",
      component: () => import("@/src/views/sign_in/index.vue"),
    },
    {
      path: "/",
      redirect: "/meal-plan/baby",
      beforeEnter: onCheckLogin,
      component: TheLayout,
      children: [
        {
          path: "/meal-plan/baby",
          component: () => import("@/src/views/meal_plan/BabyFood.vue"),
        },
        {
          path: "/meal-plan/others",
          component: () => import("@/src/views/meal_plan/Others.vue"),
        },
        {
          path: "/meal-plan/set",
          component: () => import("@/src/views/meal_plan/Set.vue"),
        },
        {
          path: "/meal-plan/excel",
          component: () => import("@/src/views/meal_plan/Excel.vue"),
        },

        {
          path: "/product",
          component: () => import("@/src/views/product/Product.vue"),
        },
        {
          path: "/product/allergy",
          component: () => import("@/src/views/product/Allergy.vue"),
        },
        {
          path: "/product/ingredient",
          component: () => import("@/src/views/product/Ingredient.vue"),
        },

        {
          path: "/order",
          component: () => import("@/src/views/order/Dps.vue"),
        },
        {
          path: "/order/update/meal",
          component: () => import("@/src/views/order/UpdateMeal.vue"),
        },
        {
          path: "/order/mes",
          component: () => import("@/src/views/order/Mes.vue"),
        },
        {
          path: "/order/production/output",
          component: () => import("@/src/views/order/ProductionOutput.vue"),
        },

        {
          path: "/shipping/holiday",
          component: () => import("@/src/views/shipping/ShippingHoliday.vue"),
        },
        {
          path: "/shipping/block-area",
          component: () => import("@/src/views/shipping/ShippingBlockArea.vue"),
        },
        {
          path: "/shipping/dawn-area",
          component: () => import("@/src/views/shipping/ShippingDawnArea.vue"),
        },
        {
          path: "/shipping/fee-group",
          component: () => import("@/src/views/shipping/ShippingFeeGroup.vue"),
        },

        {
          path: "/customer-group",
          component: () => import("@/src/views/customer_group/CustomerGroup.vue"),
        },
      ],
    },
  ],
});

export default router;
